import { ChangeDetectionStrategy, Component, computed, effect, Signal, signal, untracked } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { InventoryTransactionTypeMultiSelectComponent } from '../../../inventory';
import { ReportParameterBase } from './report-parameter-base';

@Component({
    selector: 'app-inventory-transaction-type-multi-select-parameter',
    imports: [InventoryTransactionTypeMultiSelectComponent],
    template: `
        <app-inventory-transaction-type-multi-select
            [selectedInventoryTransactionTypeKeys]="transactionTypeKeys()"
            [id]="parameterDefinition().key"
            [subscriberKey]="subscriberKey()"
            [placeHolder]="subscriberKey() != null ? parameterDefinition().placeholder : 'Select a subscriber first'"
            [invalid]="isInvalid()"
            [disabled]="isDisabled()"
            (blur)="onBlur()"
            (loadingChange)="onLoadingChange($event)"
            (selectedInventoryTransactionTypeKeysChange)="onSelectedKeysChange($event)"
        />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: InventoryTransactionTypeMultiSelectParameterComponent,
            multi: true
        }
    ]
})
export class InventoryTransactionTypeMultiSelectParameterComponent extends ReportParameterBase<number[]> {
    transactionTypeKeys = signal<number[]>([]);
    subscriberKey: Signal<number | null> = this.reportWorkspace.subscriberKey;

    override isDisabled = computed(() => this.reportWorkspace.isReportRunning() || this.isFormControlDisabled() || !this.subscriberKey());

    constructor() {
        super();

        /* Clear selection when subscriber changes */
        effect(() => {
            this.subscriberKey();
            const parameterDefinition = untracked(this.parameterDefinition);

            if (!this.isInitialized) {
                return;
            }

            const value = (parameterDefinition.emptyValue as number[]) ?? [];

            this.transactionTypeKeys.set(value);
            this.reportWorkspace.setParam(parameterDefinition.key, value);
            this.onChange(value);

            this.formControl?.markAsUntouched();
            this.formControl?.markAsPristine();
        });
    }

    onSelectedKeysChange(keys: number[]) {
        this.transactionTypeKeys.set(keys);

        this.reportWorkspace.setParam(this.parameterDefinition().key, keys);

        this.onChange(keys);
        this.markTouchedIfNotResetting();
    }

    onLoadingChange(loading: boolean) {
        this.reportWorkspace.setParamLoading(this.parameterDefinition().key, loading);
    }

    onBlur() {
        this.onTouched();
    }

    // CVA callbacks
    writeValue(obj: number[]): void {
        this.transactionTypeKeys.set(obj ?? []);
    }
}
